import { useLanguage } from "../contexts/LanguageContext";
import { InboxIcon } from "@heroicons/react/24/outline";

export default function EmptyState({
  title = "common.noRecords",
  description = "common.noRecordsDescription",
  icon: Icon = InboxIcon,
  className = "",
}) {
  const { t } = useLanguage();
  return (
    <div
      className={`text-center py-12 border border-gray-300 bg-white border-dashed rounded-lg space-y-2 p-4 ${className}`}
    >
      <div className="mx-auto h-12 w-12 text-gray-400">
        <Icon className="h-full w-full" aria-hidden="true" />
      </div>
      <h3 className="text-sm font-semibold text-gray-900">{t(title)}</h3>
      <p className="text-sm text-gray-500">{t(description)}</p>
    </div>
  );
}
